
export class ProcedureResultDataModel {
    PatientID: string;
    PatientName: string;
    Gender: string;
    Age: string;
    SampleNo: string;
    RequestDate: string;
    RequestTime: string;
    REQ_DATE: string;
    Sponsor: string;
    TestName: string;
    ResultName: string;
    ObservedValue: string;
    RefRange: string;
    Suffix: string;
    ServiceType: string;
    ResultType: string;
    AbnormalFlag: string;
    DoctorName: string;
    REMARKS: string;
    Growth_Flag: string;

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/Procedure/ProcedureResultDataModel.ts